import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { JOBS_PORTAL_URL } from '../../Services/courseService';
import { toast } from 'react-toastify';
import './JobList.css';

function MyApplications() {
  const [jobs, setJobs] = useState([]);
  const studentId = localStorage.getItem('userId');
  const API_URL = `${JOBS_PORTAL_URL}/api`;

  useEffect(() => {
    axios.get(`${API_URL}/registrations/student/${studentId}`)
      .then(res => setJobs(res.data))
      .catch((e)=>{}  );
  }, []);

  return (
    <div className="job-container">
      <h2 className="job-title">My Applications</h2>
      {jobs.length === 0 ? (
        <p className="job-no-apps">No applications found.</p>
      ) : (
        <div className="job-grid">
          {jobs.map(job => (
            <div className="job-card" key={job.id}>
              <h3>{job.title}</h3>
              <p>{job.description}</p>
              <p><strong>Location:</strong> {job.location}</p>
            </div>
          ))}
        </div>
      )}
    </div>

  );
}

export default MyApplications;
